import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import UpcastWriter from '@ckeditor/ckeditor5-engine/src/view/upcastwriter';

class ClipboardInputTransformation extends Plugin {
  init() {
    const editor = this.editor;
    const view = editor.editing.view;
    const viewDocument = view.document;

    const clipboardPipeline = editor.plugins.get('ClipboardPipeline');
    const writer = new UpcastWriter(viewDocument);

    clipboardPipeline.on('inputTransformation', (evt, data) => {
      const htmlString = data.dataTransfer.getData('text/html');

      if (htmlString) {
        if (isAnnotationFragment(data.content)) {
          const event = new CustomEvent('ckeditor-annotation-paste', {
            bubbles: true,
            detail: {
              editor,
              evt,
              data,
              element: data.content.getChild(0),
            },
          });
          window.dispatchEvent(event);
          return;
        }
        const children = data.content.getChildren();
        const cb = this.clearElement.bind(this, writer);
        this.traverseChildren(children, cb);
      }
    });
  }

  clearElement(writer, element) {
    // font-family causes issues because it cannot be changed in CK
    // if copied from google docs
    writer.removeStyle('font-family', element);
    // white-space causes issues because it prevents text
    // from wrapping on a new line
    writer.removeStyle('white-space', element);

    // remove unnecessary attrs
    writer.removeAttribute('data-rich-links', element);
    writer.removeAttribute('data-sheets-value', element);
    writer.removeAttribute('data-sheets-userformat', element);
  }

  traverseChildren(children, callback) {
    for (const element of children) {
      if (!element.is('element')) continue;
      callback(element);
      if (element.childCount > 0) {
        this.traverseChildren(element.getChildren(), callback);
      }
    }
  }
}

function isAnnotationFragment(documentFragment) {
  if (documentFragment.childCount > 1) return false;
  const child = documentFragment.getChild(0);
  const isAnnotation = child.is('element') && child.hasClass('annotation');
  return isAnnotation;
}

export default ClipboardInputTransformation;
